"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormNumberField = void 0;
const number_field_1 = require("../../../components/number-field/number-field");
const form_field_1 = require("./form-field");
exports.FormNumberField = form_field_1.formFieldFactory(number_field_1.NumberField);
//# sourceMappingURL=form-number-field.js.map